import Footer from './Footer';
import Success from '../../../../assets/images/success-payment.svg';

const PaymentSuccess: React.FC = () => {
  return (
    <div className="flex flex-col w-full justify-center">
      <div className="flex flex-col items-center justify-center py-16">
        <img src={Success} alt="Success" className="w-fit h-fit mb-8" />

        <h2 className="text-[28px]  text-displayBlack font-semibold mb-[3px]">
          Payment Successful!
        </h2>
        <p className=" text-secondaryGrayscale font-normal text-sm text-center">
          Thanks for your payment! 🎉 Your transaction has been
          <br />
          successfully processed.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentSuccess;
